import ApiURL from '../Api/Api';

export async function fetchTransactionPhotoRequired(userId) {
  if (!userId) return false;
  const response = await fetch(`${ApiURL}/getTransactionPhotoSettings.php?user_id=${userId}`);
  const data = await response.json();
  if (data.status !== 'success') {
    throw new Error(data.message || 'Failed to load transaction photo setting');
  }
  return Boolean(data.transaction_photo_required);
}

export function imagePayload(imageState) {
  return imageState?.dataUrl || '';
}

export function transactionImageUrl(path) {
  const clean = String(path || '').trim();
  if (!clean) return '';
  if (/^https?:\/\//i.test(clean)) return clean;
  return `${ApiURL.replace(/\/$/, '')}/${clean.replace(/^\/+/, '')}`;
}
